import { render, staticRenderFns } from "./Modal_mobile_promotion.vue?vue&type=template&id=c671fcd8&"
import script from "./Modal_mobile_promotion.vue?vue&type=script&lang=js&"
export * from "./Modal_mobile_promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports